// extracted by mini-css-extract-plugin
export var background = "bn_y";
export var backgroundContainer = "bn_fp";
export var buttons = "bn_cn";
export var container = "bn_b";
export var middleWave = "bn_c5";
export var section = "bn_j";
export var text = "bn_ck";
export var textContainer = "bn_b2";
export var title = "bn_g";